import { Box, Typography } from '@mui/material';
import { get } from 'lodash';
import OrderConfirmationIcon from 'src/asset/images/billing/order-confirmation-icon.png';
import { SectionErrorBoundary } from 'src/components/ErrorBoundary/SectionErrorBoundary';
import InvoiceTemplate from 'src/components/InvoiceTemplate';

// Utilities
import { useQueryParam } from 'src/hooks/useQueryParam';
import { useQueryInvoiceStripeBySessionId } from 'src/services/queries';

const OrderConfirmation = () => {
  const session_id = useQueryParam('session_id');

  const { data, isFetching } = useQueryInvoiceStripeBySessionId(session_id || '');
  const invoiceId = get(data, 'data.invoice', '');

  return (
    <Box paddingTop={3} display={'flex'} justifyContent={'center'}>
      <Box
        width={'60%'}
        display={'flex'}
        flexDirection={'column'}
        gap={3}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <img alt={'Order Confirmation Icon'} width={135} src={OrderConfirmationIcon} />
        <Typography variant={'h5'}>Thank You For Your Order!</Typography>
        <SectionErrorBoundary resetKey="OrderConfirmation" sectionName="OrderConfirmation">
          <InvoiceTemplate invoiceId={invoiceId || ''} isFetchingInvoiceId={isFetching} />
        </SectionErrorBoundary>
      </Box>
    </Box>
  );
};

export default OrderConfirmation;
